import CustomTable from "@/components/CustomTable/CustomTable";
import { Loader } from "@/components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import ModalUser from "@/components/ModalUser/ModalUser";
import { tableau_3 } from "@/config/initData";
import { routePaths } from "@/config";
import {
  deletedUser,
  getAllUsers,
  updateStatutUser,
} from "@/features/auth/api/user.api";
import { TUser } from "@/features/auth/types";
import { ToastError, ToastGeneric } from "@/utils/toast";
import { Icon } from "@iconify/react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";
import Swal from "sweetalert2";
import "./Users.content.style.scss";

import { selectUserConnected } from "@/store/reducers/user/user.selector";
import { createStructuredSelector } from "reselect";

type PropsFromRedux = ConnectedProps<typeof connector>;

const CtUsers: React.FC<PropsFromRedux> = ({ userConnected }) => {
  // Les variable de responsivité
  const theme = useTheme();
  const navigate = useNavigate();
  const matches_down_xl = useMediaQuery(theme.breakpoints.down("xl"));
  // const matches_down_lg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches_down_sm = useMediaQuery(theme.breakpoints.down("sm"));

  // les varibale du modal d'ajout d'un nouvel utilisateur
  const [openHelp, setOpenHelp] = useState(false);
  const [isForUpdateOrDelete, setIsForUpdateOrDelete] = useState(0);
  const [isUpdate, setIsUpdate] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [isForDelete, setIsForDelete] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [userDeletedId, setUserDeletedId] = useState("");

  const [isForLocked, setIsForLocked] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [userLockedId, setUserLockedId] = useState("");

  const [userId, setUserId] = useState("");
  const [currentUser, setCurrentUser] = useState<TUser>();
  const [value, setValue] = useState<TUser[]>([]);

  const [searchTerm, setSearchTerm] = useState("");

  const handleOpenHelp = () => setOpenHelp(true);
  const handleCloseHelp = () => setOpenHelp(false);
  const [usersData, setUsersData] = useState<TUser[]>([]);

  const handleCloseDelete = () => {
    setIsForDelete(false);
    setIsForLocked(false);
    setUserId("");
  };

  // Action du bouton pour la mise à jour et la suppression d'un utilisateur
  const checkIsForUpdateOrDelete = (
    e: React.MouseEvent<HTMLButtonElement>,
    userId?: string,
    user?: TUser
  ) => {
    const currentTarget = e.target as HTMLButtonElement;

    if (currentTarget.id === "button_update") {
      setUserId(userId!);
      setIsForDelete(false);
      setIsForLocked(false);
      setIsForUpdateOrDelete(1);
      setIsUpdate(true);
    }

    if (currentTarget.id === "button_delete") {
      setUserDeletedId(userId!);
      setIsForUpdateOrDelete(2);
      setIsForDelete(true);
    }

    if (currentTarget.id === "button_locked") {
      setUserLockedId(userId!);
      setIsForUpdateOrDelete(3);
      setIsForLocked(true);
    }
  };

  // Confirmation suppression ou block
  const confirmActiveOrDeleteAccount = (
    idUser: string,
    isLocked?: boolean,
    isUnLocked?: boolean
  ) => {
    console.log(" isLocked ", isLocked);
    console.log(" isUnLocked ", isUnLocked);

    Swal.fire({
      title: isUnLocked
        ? "Désactivation de compte"
        : isLocked
          ? "Activation de compte"
          : " Suppression",
      text:
        "Vous êtes sur le point " +
        (isUnLocked
          ? "de désactiver un compte"
          : isLocked
            ? "d'activer un compte"
            : " supprimer un compte") +
        " désirez-vous poursuivre cette action ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      confirmButtonColor: "#f2a252",
      cancelButtonColor: "#91949c",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        if (!isLocked && !isUnLocked) {
          deleteUser(idUser);
        }

        console.log("isLocked ", isLocked);
        console.log("isUnLocked ", isUnLocked);

        if (isLocked && !isUnLocked) {
          activeOrDesactiveUser(idUser, true);
        }

        if (!isLocked && isUnLocked) {
          activeOrDesactiveUser(idUser, false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  };

  const deleteUser = async (userId: string) => {
    deletedUser(userId)
      .then((response) => {
        setIsLoading(false);
        if (response.error) {
          ToastError.fire({ text: response.message, timer: 9000 });
        } else {
          ToastGeneric(
            "Opération effectuée avec succès",
            "success",
            3000
          ).fire();
          refreshData();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const activeOrDesactiveUser = async (
    userId: string,
    isActiveAccount: boolean
  ) => {
    const request = {
      statut: isActiveAccount ? 1 : 2,
    };

    console.log(" request ", request);

    updateStatutUser(userId, request)
      .then((response) => {
        setIsLoading(false);
        if (response.error) {
          ToastError.fire({ text: response.message, timer: 9000 });
        } else {
          ToastGeneric(
            "Opération effectuée avec succès",
            "success",
            3000
          ).fire();
          refreshData();
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  // Récupération des profils utilisateurs
  const getUsersList = async () => {
    const { data } = await getAllUsers();

    console.log("userConnected ", userConnected);

    const dataWithNewObjectKeys: TUser[] = data.map(
      (user: any, index: number) => {
        return {
          id: index + 1,
          nom: user.nom,
          prenoms: user.prenoms,
          email: user.email,
          profil_id: user.profil_id.libelle,
          telephone: user.telephone.toString(),
          is_actif: user.is_actif === 1 ? "Activé" : "Désactivé",
          actions: () => {
            return (
              <span className="actions-container">
                <button
                  style={{ backgroundColor: "transparent" }}
                  id="button_update"
                  type="button"
                  className="button-"
                  onClick={(e) => checkIsForUpdateOrDelete(e, user.id, user)}
                >
                  <Icon icon="line-md:edit-filled" />
                </button>
                {!(userConnected?.id === user.id) && (
                  <button
                    id="button_locked"
                    type="button"
                    className="button-"
                    style={{ backgroundColor: "transparent" }}
                    title={
                      user.is_actif === 0 || user.is_actif === 2
                        ? "Activé"
                        : "Désactiver"
                    }
                    onClick={(e) =>
                      confirmActiveOrDeleteAccount(
                        user.id,
                        user.is_actif === 0 || user.is_actif === 2
                          ? true
                          : false,
                        user.is_actif === 0 || user.is_actif === 2
                          ? false
                          : true
                      )
                    }
                  >
                    {user.is_actif === 1 && (
                      <Icon color="var(--ui-tertiary)" icon="wpf:unlock" />
                    )}
                    {(user.is_actif === 0 || user.is_actif === 2) && (
                      <Icon color="red" icon="gridicons:lock" />
                    )}
                  </button>
                )}
                {false && (
                  // !(userConnected?.id === user.id) &&
                  <button
                    id="button_delete"
                    type="button"
                    className="button-delete"
                    onClick={(e) =>
                      confirmActiveOrDeleteAccount(user.id, false, false)
                    }
                  >
                    <Icon icon="ion:trash-outline" />
                  </button>
                )}
              </span>
            );
          },
        };
      }
    );
    setUsersData(dataWithNewObjectKeys);
  };

  // Récupération d'un utilisateur
  const getUsersWithIds = async () => {
    const { data } = await getAllUsers();
    const dataWithNewObjectKeys: TUser[] = data.map(
      (user: any, index: number) => {
        return {
          id: user.id,
          nom: user.nom,
          prenoms: user.prenoms,
          email: user.email,
          profil_id: user.profil_id.id,
          telephone: user.telephone,
        };
      }
    );
    setValue(dataWithNewObjectKeys);
  };

  // Ouvrir le modal pour le formulaire d'ajout d'un user
  const handleOpenNewUserModal = () => {
    setUserId("");
    console.log("Ici le user ID sessez etre vide", userId);
    handleOpenHelp();
  };

  const handleDeletedOrLockedUser = () => {
    if (isForDelete) {
      setUserId(userDeletedId);
      console.log("Id user deleted", userDeletedId);
      setIsDelete(true);
      setIsLocked(false);
      handleCloseDelete();
    }

    if (isForLocked) {
      setUserId(userLockedId);
      setIsLocked(true);
      setIsDelete(false);
      handleCloseDelete();
      console.log("Désativation");
    }

    // Fonction pour rafrechir la liste des utilisateurs
  };
  const refreshData = () => {
    getUsersList();
    getUsersWithIds();
  };

  useEffect(() => {
    let userCurrent = null;

    // lorsque c'est une mise à jour
    if (userId && isUpdate) {
      userCurrent = value.find((item) => item.id === userId);
      if (userCurrent) {
        setCurrentUser(userCurrent);
        handleOpenHelp();
      }
    }

    // Lorsque c'est une suppression
    if (userId && isDelete) {
      userCurrent = value.find((item) => item.id === userId);
      if (userCurrent) {
        setCurrentUser(userCurrent);
      }
    }

    // Lorsque c'est une suppression
    if (userId && isLocked) {
      userCurrent = value.find((item) => item.id === userId);
      if (userCurrent) {
        setCurrentUser(userCurrent);
      }
    }
  }, [userId, isForUpdateOrDelete]);

  useEffect(() => {
    if (!openHelp) {
      setUserId("");
    }
  }, [openHelp]);

  useEffect(() => {
    getUsersList();
    getUsersWithIds();
  }, []);

  // Function to handle search input
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Filtered users data based on search term
  const filteredUsersData = usersData.filter(
    (user) =>
      user.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <PerfectScrollbar className="ct-home">
        <Box>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={2}
            justifyContent="flex-end"
          >
            {/* ====== ROW ====== */}
            <>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <DisplayContentAlt height={"80px"}>
                  <h2 className="uppercase"> Gestion des utilisateurs</h2>
                </DisplayContentAlt>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >

                
                <Button
                  className="filter-button"
                  onClick={handleOpenNewUserModal}
                  variant="contained"
                  type="submit"
                  sx={{ marginRight: 2 }} // Espace avec l'autre bouton
                  startIcon={<Icon icon="bxs:user-plus" />}
                >
                  Ajouter
                </Button>
                <Button
                  className="filter-button"
                  variant="outlined" // Style différent pour distinguer
                  onClick={() => navigate(routePaths.profileChildren.logsAbsolute)}
                >
                  Historique de connexion
                </Button>
              </Grid>
            </>
            {/* ====== end of a ROW ====== */}
            <ModalUser
              currentUser={currentUser}
              user_id={userId}
              isForUpdateOrDelete={isForUpdateOrDelete}
              open={openHelp}
              onClose={handleCloseHelp}
              closeClick={handleCloseHelp}
              refreshUserListe={refreshData}
            />
            <Dialog
              open={isForDelete || isForLocked}
              onClose={handleCloseDelete}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {isForDelete && "Attention suppression en cours"}
                {isForLocked && "Attention Désactivation en cours"}
                {/* { !isForLocked && "Attention activation en cours"} */}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {isForDelete &&
                    "Vous êtes sur le point de supprimer ce utilisateur. Êtes-vous sûr(e) de vouloir le faire ?"}
                  {isForLocked &&
                    "Vous êtes sur le point de désactiver ce utilisateur. Êtes-vous sûr(e) de vouloir le faire ?"}
                  {/* { !isForLocked && "Vous êtes sur le point d'activer ce utilisateur. Êtes-vous sûr(e) de vouloir le faire ?"} */}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button color="tertiary" onClick={handleCloseDelete}>
                  Annuler
                </Button>
                <Button
                  color="error"
                  onClick={handleDeletedOrLockedUser}
                  autoFocus
                >
                  {isForDelete && "Supprimer"}
                  {isForLocked && "Désactiver"}
                  {/* { !isForLocked && "Activer"} */}
                </Button>
              </DialogActions>
            </Dialog>
            {/* ====== ROW ====== */}
            <>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <DisplayContent
                  height={
                    matches_down_xl
                      ? matches_down_sm
                        ? "fit-content"
                        : "95vh"
                      : "95vh"
                  }
                >
                  <Loader isLoading={isLoading} />

                  <CustomTable
                    headers={tableau_3.headers}
                    rows={filteredUsersData}
                    title={tableau_3.title}
                    headerColor="var(--ui-tertiary)"
                    textColor="var(--ui-white)"
                    titleExport={tableau_3.titleExport}
                    colsToExport={tableau_3.colsToExport}
                    rowsPerPage={matches_down_xl ? 8 : 10}
                    searchTerm={searchTerm}
                    handleSearchChange={handleSearchChange}
                    table="users"
                  />
                </DisplayContent>
              </Grid>
            </>
            {/* ====== end of a ROW ====== */}
          </Grid>
        </Box>
      </PerfectScrollbar>
    </>
  );
};

const DisplayContent = styled.div<{ height: string }>`
  width: 100%;
  height: ${({ height }) => {
    return height;
  }};
  border-radius: 5px;
  background: var(--ui-white);
  box-shadow: 0px 0px 30px #ededed;
`;

const DisplayContentAlt = styled.div<{ height: string }>`
  width: 100%;
  height: ${({ height }) => {
    return height;
  }};
  border-radius: 5px;
  display: flex;
  align-items: center;

  h2 {
    color: var(--ui-dark);
  }
`;

const mapStateToProps = createStructuredSelector({
  userConnected: selectUserConnected,
});

const connector = connect(mapStateToProps);
const User = connector(CtUsers);

export default User;
